export default __webpack_public_path__ + "static/media/order_img.916c66f2.png";